const { getSchemaNamespace } = require('@wix/wix-data-utils');
export function isDriverCollection(schema) {
    return schema.storage === 'driver';
}
export function isNativeCollection(schema) {
    return schema.storage === 'docstore';
}
export function isAppBuilderCollection(collectionName) {
    return (collectionName.includes('/') &&
        collectionName.includes('.') &&
        collectionName.indexOf('.') < collectionName.indexOf('/'));
}
export function isConnectorSchema(schema) {
    return schema.storage === 'external';
}
export function isDynamicApplicationSchema(schema) {
    return schema.storage === 'dynamicApplication';
}
export function isSameNamespace(collectionA, collectionB) {
    return getSchemaNamespace(collectionA) === getSchemaNamespace(collectionB);
}
//# sourceMappingURL=schema-utils.js.map